<div class="modal-content">
    <div class="row">
        <div class="col-sm-12">
            <button class="close mr-4 mt-2" type="button" (click)="close()"><i class="fa fa-times"></i></button>
        </div>

        <ng-container *ngIf="confirmData">
            <div class="col-sm-12" *ngIf="confirmData?.title">
                <h2 class="text-center mt-3">{{confirmData?.title}}</h2>
            </div>
        
            <div class="col-sm-12 px-5 mb-2 max-height mt-5" *ngIf="confirmData?.header">
                <div class="table-responsive">
                    <table class="table table-hover table-bordered border">
                        <thead *ngIf="confirmData?.header">
                            <tr>
                                <th class="bg-primary" *ngFor="let item of confirmData?.header">{{item.label}}</th>
                            </tr>
                        </thead>
                        <tbody *ngIf="confirmData?.data">
                            <ng-container *ngFor="let itemData of confirmData?.data">
                                <tr>
                                    <td *ngFor="let item of confirmData?.header">
                                        <ng-container *ngTemplateOutlet="inputTableTemplate; context: { $implicit: {campo: itemData[item.key]} }">
                                        </ng-container>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </ng-container>

    </div>
</div>

<ng-template #inputTableTemplate let-elemento>
    <ng-container [ngSwitch]="elemento?.campo?.type">
        <ng-container *ngSwitchCase="'rut'">
            {{elemento?.campo?.value | rutFormat}}
        </ng-container>
        <ng-container *ngSwitchCase="'date'">
            {{elemento?.campo?.value | date:'dd-MM-yyyy'}}
        </ng-container>
        <ng-container *ngSwitchCase="'intNumber'">
            {{elemento?.campo?.value | number: '1.0-0'}}
        </ng-container>
        <ng-container *ngSwitchCase="'decNumber'">
            {{elemento?.campo?.value | number: '1.0-2'}}
        </ng-container>
        <ng-container *ngSwitchCase="'periodo'">
          {{elemento?.campo?.value | date:'LLL yyyy' | titlecase}}
      </ng-container>
        <ng-container *ngSwitchDefault>
            {{elemento?.campo?.value || ''}}
        </ng-container>
    </ng-container>
</ng-template>
